import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import { Location, PlatformLocation } from "@angular/common";
import { TokenService } from "./../token/token.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { LocalstorageService } from '../localstorage/localstorage.service';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
declare let moment: any;

@Injectable()
class Interceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private location: Location,
    private tokenService: TokenService,
    private spinner: NgxSpinnerService,
    private platfLocation: PlatformLocation,
    private toastr: ToastrService,
    private localStorageService: LocalstorageService,
    private translate: TranslateService
  ) {
    this.platfLocation.onPopState(() => {
      this.resetLoading();
    });

    this.location.onUrlChange(() => {
      this.totalRequests = 0;
    });
  }

  totalRequests = 0;
  whiteList = [
    (environment.apiGestorUrlLocal + 'api/notificacao-sistema/avisos'),
    (environment.apiGestorUrlLocal + 'api/notificacao-sistema/ocultar'),
    (environment.apiGestorUrlLocal + 'api/chat/contadores-meus-chats'),
    (environment.apiGestorUrlLocal + 'api/chat/listagem-meus-chats'),
    (environment.apiGestorUrlLocal + 'api/chat/marcar-como-lido/'),
    (environment.apiGestorUrlLocal + 'api/whatsapp/obter-integracao'),
    (environment.apiGestorUrlLocal + 'api/clientes/dropdown-paginado'),
    (environment.apiGestorUrlLocal + 'api/clienteContato/list'),
    (environment.apiGestorUrlLocal + 'api/whatsapp/obter-integracao'),
    (environment.apiGestorUrlLocal + 'api/whatsapp/testar-integracoes'),
    (environment.apiGestorUrlLocal + 'api/base-conhecimento/arvore'),
    (environment.apiGestorUrlLocal + 'api/campos-personalizados/validacao/especificas'),
    (environment.apiGestorUrlLocal + 'api/integracao-agenda/validaAuthTecnico'),
    (environment.apiGestorUrlLocal + 'api/chatGpt/comment-sugestao-de-texto-modal/'),
    (environment.apiGestorUrlLocal + 'api/integracao-agenda/validaAuthOutlookTecnico'),
    (environment.apiGestorUrlLocal + 'api/mensagens/enviar-mensagens'),
    (environment.apiGestorUrlLocal + 'api/chamados/contador/'),
    (environment.apiGestorUrlLocal + 'api/chatGpt/sugestao'),
    (environment.apiGestorUrlLocal + 'api/template-resposta/listagem'),
    (environment.apiGestorUrlLocal + 'api/chat/mensagens-visualizadas'),
    (environment.apiGestorUrlLocal + 'api/whatsapp/status-numeros-operador')
  ];
  endpointsTratados = [
    (environment.apiGestorUrlLocal + 'api/clienteContato/pre-vinculacao')
  ];
  // endpoints com id dinâmico na URL (ex: /:id), tratados por prefixo em vez de igualdade exata
  endpointsTratadosPrefixo = [
    (environment.apiGestorUrlLocal + 'api/contratos/parcelas/atualizar-dados/')
  ];
  loadingTimeout: any;
  stopIntercept: boolean = false;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;
    if (this.tokenService.getToken() && headers.has('authorization') && (headers.get('authorization') !== this.tokenService.getToken())) {
      headers = headers.delete('authorization').set('authorization', this.tokenService.getToken());
      const clonedRequest = request.clone({
        headers: headers
      });

      if (!this.stopIntercept) {
        this.verificaWhitelist(clonedRequest.url);
        this.totalRequests++;

        this.verificaLogoutAutomatico();

        return next.handle(clonedRequest).pipe(map((event: HttpEvent<any>) => {
          this.verificaStatusEvent(event['status']);

          if (this.totalRequests <= 0) {
            this.spinner.hide();
          }

          return event;
        }), catchError((error: HttpErrorResponse) => {
          this.resetLoading();
          this.msgErrorResponse(error)
          return throwError(() => error)
        }));
      } else {
        return next.handle(clonedRequest);
      }
    } else {
      if (!this.stopIntercept) {
        this.verificaWhitelist(request.url);
        this.totalRequests++;

        this.verificaLogoutAutomatico();

        return next.handle(request).pipe(map((event: HttpEvent<any>) => {
          this.verificaStatusEvent(event['status']);

          if (this.totalRequests <= 0) {
            this.spinner.hide();
          }

          return event;
        }), catchError((error: HttpErrorResponse) => {
          this.resetLoading();
          this.msgErrorResponse(error)
          return throwError(() => error)
        }));
      } else {
        return next.handle(request);
      }
    }
  }

  verificaStatusEvent(status) {
    if (status) {
      this.totalRequests--;
    }
  }

  msgErrorResponse(error): void {
    setTimeout(() => {
      if (!this.verificaEndpointsTratados(error)) {
        //evita muitos toastrs ou mostrar msg padrão caso componente já tenha tratamento
        if (!document.querySelector('.ngx-toastr.alert-danger') && !document.querySelector('.ngx-toastr.alert-warning')) {
          const error_msgs = this.identificaMsgUsuario(error);
          // this.toastr.show(error_msgs.user, '', {
          //   disableTimeOut: error_msgs.msg_fixa,
          //   closeButton: false,
          //   enableHtml: true,
          //   tapToDismiss: true,
          //   titleClass: "alert-title",
          //   positionClass: "toast-top-center",
          //   toastClass:
          //     "ngx-toastr alert alert-dismissible alert-danger alert-notify",
          // });
          console.error("[API_ERROR_INTERCEPTOR]: ", error_msgs.user);
        }
      } else {
        if (!document.querySelector('.ngx-toastr.alert-danger') && !document.querySelector('.ngx-toastr.alert-warning')) {
          const error_msgs = this.identificaMsgUsuario(error);
          this.toastr.show(error_msgs.user, '', {
            disableTimeOut: error_msgs.msg_fixa,
            closeButton: false,
            enableHtml: true,
            tapToDismiss: true,
            titleClass: "alert-title",
            positionClass: "toast-top-center",
            toastClass:
              "ngx-toastr alert alert-dismissible alert-danger alert-notify",
          });
        }
      }
    }, 100);
  }

  resetLoading(): void {
    this.totalRequests = 0;
    this.spinner.hide();
    clearTimeout(this.loadingTimeout);
  }

  resetCachedFiles(): void {
    window.location.replace(window.location.href);
  }

  verificaWhitelist(url: string): void {
    if (!this.router.routerState.snapshot.url.includes('/tickets/details/') && !this.router.routerState.snapshot.url.includes('/tickets/list')) {
      var urlWithoutParams = url.split('?');
      if (urlWithoutParams[0] &&
        (urlWithoutParams[0].includes('dropdown') ||
          urlWithoutParams[0].includes('api/campos-personalizados/lista/opcoes/todas/') ||
          urlWithoutParams[0].includes('api/categorias-multi-niveis/arvore-cliente') ||
          urlWithoutParams[0].includes('api/ia-chamado') ||
          urlWithoutParams[0].includes('api/chatGpt/funcionalidades-habilitadas') ||
          urlWithoutParams[0].includes('api/base-conhecimento/artigo')) ||
        urlWithoutParams[0].includes('marcar-como-lido')) {
        return;
      }

      if (this.whiteList.includes(urlWithoutParams[0]) === false) {
        this.spinner.show();
        this.verificaLoadingTravado();
      }
    }
  }

  calculaTempoLogado(): number {
    let user = this.tokenService.getUsuario();
    let agora: any = new Date();
    let ultimo_login: any = user && user.ultimo_login ? new Date(user.ultimo_login) : new Date();
    let diff = new moment.duration(agora - ultimo_login);

    return Math.floor(diff.asHours());
  }

  verificaLogoutAutomatico(): void {
    if (this.tokenService.hasToken()) {
      this.verificaDiffTimeEFullscreen();
    } else {
      this.verificaActualRoute();
    }
  }

  redirecionaTelaLogin() {
    this.resetLoading();
    this.router.navigate(['/login']);
  }

  salvaTemaPortal(sessao_expirada?) {
    this.localStorageService.logoutWithLocalData(null, sessao_expirada ? sessao_expirada : null);
  }

  verificaDiffTimeEFullscreen() {
    const diffTime = this.calculaTempoLogado();
    if (this.tokenService.getTipoPerfilUsuario() === 4) {
      if (diffTime >= 168 && document.fullscreenElement === null && !this.stopIntercept) {
        this.stopIntercept = true;
        let actualRoute = this.location.path().substring(1).split('/');
        if (actualRoute[0] === 'outside-auth') {
          let redirect = actualRoute[1].split('confirm-auth?');
          window.localStorage.setItem('bc_redirect_auth', redirect[1]);
        }

        this.salvaTemaPortal();
        this.resetLoading();
      }
    } else {
      if (diffTime >= 10 && document.fullscreenElement === null && !this.stopIntercept) {
        this.stopIntercept = true;
        let actualRoute = this.location.path().substring(1).split('/');
        if (actualRoute[0] === 'outside-auth') {
          let redirect = actualRoute[1].split('confirm-auth?');
          window.localStorage.setItem('bc_redirect_auth', redirect[1]);
        }

        this.salvaTemaPortal();
        this.resetLoading();
      }
    }
  }

  verificaActualRoute() {
    let actualRoute = this.location.path().substring(1).split('/');
    if (!actualRoute[0].includes('chats-list') && !actualRoute[0].includes('reply-message')) {
      if (actualRoute[0] === 'outside-auth') {
        const qs = new URLSearchParams(this.location.path().split('?')[1] || '');
        if (qs.get('redirect')) {
          window.localStorage.setItem(
            'bc_redirect_auth',
            'redirect=' + qs.get('redirect') + '&state=' + encodeURIComponent(qs.get('state') || '')
          );
        }
        this.redirecionaTelaLogin();
      } else {
        if (actualRoute.length === 4 && actualRoute[3] === 'true') {
          this.router.navigateByUrl(this.location.path().substring(1));
          this.resetLoading();
        } else {
          this.redirecionaTelaLogin();
        }
      }
    }
  }

  verificaLoadingTravado(): void {
    clearTimeout(this.loadingTimeout);
    this.loadingTimeout = setTimeout(() => {
      if (this.totalRequests !== 0) {
        this.totalRequests = 0;
        this.spinner.hide();
      }
    }, 3000);
  }

  identificaMsgUsuario(error): any {
    let error_msg =
      typeof error.error === 'string'
        ? error.error
        : typeof error?.error?.error_msg === 'string'
          ? error.error.error_msg
          : error?.error?.message
            ? error.error.message
            : error?.error?.error
              ? error.error.error
              : null;
    switch (error.status) {
      case 0:
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_CONEXAO'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: true
        };
      case 400:
        return {
          user: error_msg ? error_msg : this.translate.instant('OPERACAO_FALHOU'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 401:
        if (error_msg && (error_msg.includes('sessão') || error_msg.includes('session') || error_msg.includes('sesión'))) {
          if (!this.stopIntercept) {
            this.stopIntercept = true;
            this.localStorageService.removeStoredItem("deviceId");
            // setTimeout(() => {
            this.resetLoading();
            this.salvaTemaPortal(error.error ? error.error : error);
            // this.resetCachedFiles();
            // }, 1000);
          }
          return {
            user: error_msg ? error_msg : this.translate.instant('SESSAO_EXPIRADA'),
            log: { msg: error.message, status: error.status, url: error.url },
            msg_fixa: true
          };
        } else {
          return {
            user: error_msg ? error_msg : this.translate.instant('OPERACAO_FALHOU'),
            log: { msg: error.message, status: error.status, url: error.url },
            msg_fixa: false
          };
        }
      case 403:
        return {
          user: error_msg ? error_msg : this.translate.instant('SEM_PERMISSAO'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 404:
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_CONEXAO'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 406:
        if (!this.stopIntercept) {
          this.stopIntercept = true;
          this.localStorageService.removeStoredItem("deviceId");
          // setTimeout(() => {
          this.resetLoading();
          this.salvaTemaPortal(error.error ? error.error : error);
          // this.resetCachedFiles();
          // }, 1000);
        }
        return {
          user: error_msg ? error_msg : this.translate.instant('SESSAO_EXPIRADA'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: true
        };
      case 418:
        return {
          user: error_msg ? error_msg : this.translate.instant('DOMINIO_JA_UTILIZADO'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 429:
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_MUITAS_REQUISICOES'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 500:
        // Sentry.captureException(error);
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_INTERNO_APIS'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 503:
        // Sentry.captureException(error);
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_INTERNO_APIS'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      case 504:
        // Sentry.captureException(error);
        return {
          user: error_msg ? error_msg : this.translate.instant('ERRO_INTERNO_APIS'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
      default:
        // Sentry.captureException(error);
        return {
          user: error_msg ? error_msg : this.translate.instant('OPERACAO_FALHOU'),
          log: { msg: error.message, status: error.status, url: error.url },
          msg_fixa: false
        };
    }
  }

  verificaEndpointsTratados(erro): boolean {
    return this.endpointsTratados.includes(erro.url)
      || (typeof erro.url === 'string' && this.endpointsTratadosPrefixo.some(prefixo => erro.url.startsWith(prefixo)))
      || erro.status === 400 || erro.status === 401;
  }
}

export default Interceptor;
